export default __webpack_public_path__ + "static/media/time.fe571ef2.svg";